import apiClient from './apiClient';

export interface PublicShelter {
  id: string;
  name: string;
  description: string;
  city: string;
  county: string;
  email: string;
  phone: string;
  website: string;
  address: string;
  coordinates: { lat: number; lng: number } | null;
  working_hours: any;
  capacity: number;
  current_occupancy: number;
  status: string;
  animal_count: number;
  created_at: string;
}

export interface PublicShelterAnimal {
  id: string;
  name: string;
  species: string; // Standardizat: dog, cat, bird, rabbit, horse, other
  breed: string;
  birth_date: string;
  size: string;
  gender: string; // Standardizat: male, female (renumit din sex)
  sterilized: boolean;
  vaccinated: boolean;
  status: string; // Standardizat: available, reserved, adopted
  description: string;
  photos: string[];
  created_at: string;
  // Pentru compatibilitate
  sex?: string; // Deprecated
}

// Rute publice pentru adaposturi
export const getPublicShelters = async (params?: {
  status?: string;
  city?: string;
  county?: string;
  q?: string;
  page?: number;
  pageSize?: number;
}) => {
  const response = await apiClient.get('/shelters', { params });
  return response.data;
};

export const getPublicShelterById = async (shelterId: string) => {
  const response = await apiClient.get(`/shelters/${shelterId}`);
  return response.data;
};

export const getPublicShelterAnimals = async (shelterId: string, params?: {
  status?: string;
  species?: string;
  breed?: string;
  age?: string;
  size?: string;
  gender?: string; // Standardizat (renumit din sex)
  sex?: string; // Pentru compatibilitate (deprecated)
  sterilized?: string;
  vaccinated?: string;
  sort?: string;
  page?: number;
  limit?: number;
}) => {
  // Convertește gender sau sex la formatul corect pentru API
  const apiParams: any = { ...params };
  if (!apiParams.gender && apiParams.sex) {
    // Convertim M/F la male/female pentru API
    apiParams.gender = apiParams.sex === 'M' ? 'male' : apiParams.sex === 'F' ? 'female' : apiParams.sex;
    delete apiParams.sex;
  }
  
  const response = await apiClient.get(`/shelters/${shelterId}/animals`, { params: apiParams });
  return response.data;
};

/** Catalog agregat: animale adoptabile din toate adăposturile active */
export const getAdoptableAnimalsCatalog = async (params?: {
  species?: string;
  breed?: string;
  age?: string;
  size?: string;
  gender?: string;
  sex?: string;
  sterilized?: string | boolean;
  vaccinated?: string | boolean;
  status?: string;
  city?: string;
  county?: string;
  q?: string;
  sort?: string;
  page?: number;
  limit?: number;
}) => {
  const response = await apiClient.get('/shelters/adoptable-animals', { params });
  return response.data;
};

export const getAdoptableAnimalDetail = async (animalId: string) => {
  const response = await apiClient.get(`/shelters/adoptable-animals/${animalId}`);
  return response.data;
};

export const submitAdoptionApplication = async (animalId: string, body: { notes?: string }) => {
  const response = await apiClient.post(
    `/shelters/adoptable-animals/${animalId}/applications`,
    body
  );
  return response.data;
};

const publicSheltersService = {
  getPublicShelters,
  getPublicShelterById,
  getPublicShelterAnimals,
  getAdoptableAnimalsCatalog,
  getAdoptableAnimalDetail,
  submitAdoptionApplication,
};

export default publicSheltersService;
